import { render } from "./ProviderChatView.vue?vue&type=template&id=9a441464&scoped=true&ts=true"
import script from "./ProviderChatView.vue?vue&type=script&lang=ts"
export * from "./ProviderChatView.vue?vue&type=script&lang=ts"

import "./ProviderChatView.vue?vue&type=style&index=0&id=9a441464&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a441464"]])

export default __exports__